export const Environment = {
    SKIP: 10,
    LIMIT: 10,
    INPUT_DE_BUSCA: "Pesquisar...",
    LISTAGEM_VAZIA: "Nenhum registro encontrado.",
    URL_BASE: 'https://api.qrmania.com.br'
    // URL_BASE: 'http://localhost:3000'
}